import { useEffect, useRef, useState } from "react";
import * as React from "react";
import { useReactToPrint } from "react-to-print";
import HtmlDo from "./HtmlDo";

// import ModalRegisterDetails from "../popups/ModalRegisterDetails";
// import ModalReportSheet from "../popups/ModalReportSheet";
// import ModalUserRegisterDetails from "../popups/ModalUserRegisterDetails";
// import ModalPaySlips from "../popups/ModalPaySlips";
// import ModalReceipt from "../popups/ModalReceipt";

const PrintDoc = (props) => {
  const [referenceNo, setReferenceNo] = useState("");
  const [itemIds, setItemIds] = useState([]);
  const [docTypes, setDocTypes] = useState("");
  const [title, setTitle] = useState("");
  
  useEffect(() => {
    setReferenceNo(props.referenceNo);
    setItemIds(props.id);
    setDocTypes(props.docType);
    setTitle(props.title);
  }, [
    props.referenceNo,
    props.id,
    props.docType,
    props.datesUseds,
    props.pdfPrints,
    props.title,
  ]);

  const componentRef = useRef(null);
  const handleAfterPrint = React.useCallback(() => {
    console.log("`onAfterPrint` called");
  }, []);

  const handleBeforePrint = React.useCallback(() => {
    console.log("`onBeforePrint` called");
    return Promise.resolve();
  }, []);

  const reactToPrintFn = useReactToPrint({
    contentRef: componentRef,
    documentTitle: title,
    onAfterPrint: handleAfterPrint,
    onBeforePrint: handleBeforePrint,
  });

  let tagName;
  switch (docTypes) {
    case "HtmlDo":
      tagName = <HtmlDo />;
      break;
    
    //   case "ModalPaySlips":
    //   tagName = (
    //     <ModalPaySlips
    //       itemId={props.id}
    //       direction={"2"}
    //       datesUsed={props.datesUseds}
    //       pdfPrint={false}
    //       referenceNo={referenceNo}
    //     />
    //   );
    //   break;

    //   case "ModalPayBill":
    //   tagName = (
    //     <ModalReceipt
    //       itemId={props.id}
    //       direction={"2"}
    //       pdfPrint={false}
    //       referenceNo={referenceNo}
    //     />
    //   );
    //   break;
      
    // case "ModalReportSheet":
    //   tagName = (
    //     <ModalReportSheet
    //       itemId={props.id}
    //       direction={"2"}
    //       datesUsed={props.datesUseds}
    //       pdfPrint={false}
    //       referenceNo={referenceNo}
    //     />
    //   );
    //   break;

    
    // case "ModalRegisterDetails":
    //   tagName = (
    //     <ModalRegisterDetails
    //       itemId={props.id}
    //       direction={"2"}
    //       datesUsed={props.datesUseds}
    //       pdfPrint={false}
    //       referenceNo={referenceNo}
    //     />
    //   );
    //   break;
    //   case "ModalUserRegisterDetails":
    //     tagName = (
    //       <ModalUserRegisterDetails
    //         itemId={props.id}
    //         direction={"2"}
    //         datesUsed={props.datesUseds}
    //         pdfPrint={false}
    //         referenceNo={referenceNo}
    //       />
    //     );
    //     break;

    

    // default:
    //   tagName = (
    //       <ModalUserRegisterDetails
    //         itemId={props.id}
    //         direction={"2"}
    //         datesUsed={props.datesUseds}
    //         pdfPrint={false}
    //         referenceNo={referenceNo}
    //       />
    //     );
    //   break;
  }

  return (
    <div>
      <button
        onClick={reactToPrintFn}
        className="btn btn-primary col-lg-3 mt-4 mb-4"
      >
        Print Document <i className="fa fa-print pt-1 pe-2"></i>
      </button>

      <div ref={componentRef}>{tagName}</div>
    </div>
  );
};

export default PrintDoc;
